export const SECOND_MILLIS = 1000;
export const MINUTE_MILLIS = 60 * SECOND_MILLIS;

export const DAY_TOKEN_DECIMALS = 8;
export const LAMPORTS_PER_DAY = 10 ** DAY_TOKEN_DECIMALS;
